import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layouts/index.vue'

import Login from '@/views/Login'

import store from '@/store/index'
import { PAGE_NAME } from '@/utils/constant'

import { microPhoneAuthCheck } from '@/utils/microPhoneAuthCheck'

const InactiveEmpty = () =>
  import('@/components/business/empty/InactiveEmpty.vue')
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

/**
 * @type {import('vue-router').RouteConfig[]}
 */
const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: PAGE_NAME.Home,
        component: () => import('@/views/collaboration/CollaborationList.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'organ',
        name: PAGE_NAME.Organ,
        component: () => import('@/views/organization'),
        meta: {
          keepAlive: true
        },
      },
      {
        path: 'work',
        name: 'Work',
        // TODO:编码工作台模块时，替换组件
        component: InactiveEmpty,
        meta: {
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/signin-to-code',
    name: PAGE_NAME.SigninToCode,
    component: () => import('@/views/signin-to-code')
  },
  {
    path: '/parsing-link/:conferenceId',
    name: PAGE_NAME.Parsing,
    component: () => import('@/views/parsing-link')
  },
  {
    path: '/talking/:conferenceId',
    name: PAGE_NAME.Talking,
    component: () => import('@/views/talking')
  },
  {
    path: '/login',
    name: PAGE_NAME.Login,
    component: Login
  },
  {
    path: '*',
    redirect(to) {
      if (store.getters.isLogin) {
        return {
          replace: true,
          name: PAGE_NAME.Home
        }
      } else {
        return {
          replace: true,
          name: PAGE_NAME.Exception,
          query: {
            code: '404',
            msg: '访问的页面不存在~'
          }
        }
      }
    }
  },
  {
    path: '/platformapi/startapp',
    name: PAGE_NAME.StartApp,
    redirect(to) {
      microPhoneAuthCheck()
      const query = to.query

      if (query.action === 'join_conference' && query.conferenceId) {
        return {
          replace: true,
          name: PAGE_NAME.Parsing,
          params: {
            conferenceId: query.conferenceId
          },
          query: {}
        }
      }
      return {
        replace: true,
        name: PAGE_NAME.Home
      }
    }
  },
  {
    path: '/exception',
    name: PAGE_NAME.Exception,
    component: () => import('@/views/Exception.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
